import type { ReactNode } from "react";

/** Footer strip for `/meetings/<id>`. Two slots: left for context (e.g.
 *  Meet URL + participant count), right for hints (e.g. kbd shortcuts).
 *  Matches design-handoff/project/screens-meeting.jsx:BottomBar.
 */
export function BottomBar({
  left,
  right,
}: {
  left?: ReactNode;
  right?: ReactNode;
}) {
  return (
    <div
      style={{
        padding: "8px 24px",
        borderTop: "1px solid var(--rule)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: "var(--card)",
      }}
    >
      <div>{left}</div>
      <div>{right}</div>
    </div>
  );
}
